import { gql } from '@apollo/client';

export const GET_DATA_POINTS = gql`
  query GetDataPoints($projectId: ID!) {
    dataPoints(projectId: $projectId) {
      id
      title
      description
      status
      value
      type
      isCompleted
      facility {
        id
        name
      }
      assignedTo {
        id
        email
        firstName
        lastName
      }
      newReportChapter {
        id
        newReport {
          id
          title
        }
      }
    }
  }
`;

export const GET_DATA_POINT = gql`
  query GetDataPoint($id: ID!, $projectId: ID!) {
    dataPoint(id: $id, projectId: $projectId) {
      id
      title
      description
      status
      type
      subtype
      value
      options
      metadata
      createdAt
      canBeDeleted
      commentCount
      isCompleted
      suggestionGenerationStatus
      recommendationGenerationStatus
      recommendationEligible
      facility {
        id
        name
      }
      createdBy {
        id
        email
      }
      assignedTo {
        id
        email
        firstName
        lastName
      }
      incomingSuggestions {
        id
        confidenceScore
        explanation
        sourceType
        targetType
        sourceDataPoint {
          id
          title
          value
          type
          facility {
            id
            name
          }
        }
        sourceDocumentChunk {
          id
          content
          pageIndex
          document {
            id
            originalName
          }
        }
        internetContent {
          id
          url
          title
          content
        }
        sourceEmissionFactor {
          id
          provider
          providerFactorId
          dataVersion
          name
          activityKey
          category
          scopes
          hierarchy
          source
          sourceDataset
          region
          regionName
          year
          unit
          unitType
          co2eFactor
        }
        sourceProduct {
          id
          title
          sku
          description
          unitOfMeasure
          isActive
        }
      }
      recommendation {
        id
        targetType
        suggestedValue
        explanation
        confidenceScore
        status
        feedback
      }
    }
  }
`;

export const GET_DATA_POINT_BREADCRUMB = gql`
  query GetDataPointBreadcrumb($id: ID!, $projectId: ID!) {
    dataPoint(id: $id, projectId: $projectId) {
      id
      title
    }
  }
`;
